import React from "react";
import PropTypes from "prop-types";
import styles from "./ContactList.module.css";
import ContactCard from "../ContactCard";

export function ContactList({ contacts, onEdit, onDelete }) {
  return (
    <div className={styles.contactList}>
      {contacts.map((contact, index) => (
        <div key={index} className={styles.contactCard}>
          <ContactCard
            contact={contact}
            onEdit={() => onEdit(contact)}
            onDelete={() => onDelete(contact)}
          />
        </div>
      ))}
    </div>
  );
}
ContactList.propTypes = {
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      contactId: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      phone: PropTypes.string,
    })
  ),
};
